import { createGlobalStyle, css } from 'styled-components';

import { colorsCSSVars as colorsCSVariables } from './Colors.js';
import { globalVariablesCSSVars as globalVariablesCSVariables } from './GlobalVariables.js';
import { spacingCSSVars as spacingCSVariables } from './Spacing.js';
import { typographyCSS } from './Typography.js';
import { fontSizeCSSVars as fontSizeCSVariables } from './FontSizes.js';

const normalizeCSS = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  a {
    color: revert;
  }

  table {
    border-collapse: collapse;
  }

  th {
    text-align: left;
  }
`;

export default createGlobalStyle`
  :root {
    ${colorsCSVariables}
    ${spacingCSVariables}
    ${globalVariablesCSVariables}
    ${fontSizeCSVariables}
  }

  ${typographyCSS}
  ${normalizeCSS}
`;
